<template>
  <ContentDetailWrap @back="$router.back()">
    <div>
      <div class="gap">
        <DetailTitle title="基本信息">
          <template #right>
            <span>采摘批次：</span>
            <span>{{ formData.pickingBatchBizNo || '-' }}</span>
          </template>
        </DetailTitle>

        <BaseDetail :formData="formData" />
      </div>

      <div class="gap">
        <DetailTitle title="鲜果验收结果" />

        <ReceiptResult :formData="formData" />
      </div>

      <div class="gap">
        <DetailTitle title="抽查照片" />

        <CheckImg :imgArr="imgArr" />
      </div>

      <div class="gap">
        <DetailTitle title="历史修改记录" />

        <HistoryRecord :formData="formData" />
      </div>

      <div class="gap">
        <div class="hbwtween" style="width: 70%; font-size: 14px">
          <div>操作人：{{ formData.operatorName }}</div>
          <div>操作时间： {{ parseTime(formData.inspectionDateTime, '{y}-{m}-{d} {h}:{i}') }}</div>
        </div>
      </div>
    </div>
  </ContentDetailWrap>
</template>

<script>
import ContentDetailWrap from '@/components/ContentDetailWrap.vue'
import DetailTitle from '@/components/DetailTitle.vue'
import BaseDetail from './components/BaseDetail.vue'
import ReceiptResult from './components/ReceiptResult.vue'
import CheckImg from './components/CheckImg.vue'
import HistoryRecord from './components/HistoryRecord.vue'

import { getInspectionSheetItem } from '@/api/manage/inspection-sheet-item'

export default {
  name: 'warehouseDetail',
  components: {
    ContentDetailWrap,
    BaseDetail,
    ReceiptResult,
    CheckImg,
    DetailTitle,
    HistoryRecord,
  },
  data() {
    return {
      formData: { attachments: [] },

      imgArr: [],
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      const data = await getInspectionSheetItem(this.$route.query.id)
      if (data.code == 200 && data.flag) {
        this.formData = data.data
        this.imgArr = data.data.attachments?.filter((item) => item.type === 2).map((item) => item.url) || []
      }
    },
    back() {
      this.$router.back()
    },
  },
}
</script>

<style scoped lang="less">
.gap {
  margin-bottom: 30px;
}
.hbwtween {
  display: flex;
  justify-content: space-between;
}
</style>
